export const LANGUAGE_PARAM = "language";
const DEFAULT_LANGUAGE = "en";

export const activeLanguage = ['en', 'mg', 'fr']

export const withCurrentLanguage = (target: string | URL | null | undefined): string | URL | null => {
  if (!target) return null;

  const currentUrl = new URL(window.location.href);
  const targetUrl = new URL(target.toString(), window.location.origin);

  if (targetUrl.origin !== currentUrl.origin || targetUrl.searchParams.has(LANGUAGE_PARAM)) {
    return target ?? null;
  }

  const currentLanguage = currentUrl.searchParams.get(LANGUAGE_PARAM);
  if (!currentLanguage) return target ?? null;

  targetUrl.searchParams.set(LANGUAGE_PARAM, currentLanguage);
  return `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
};

export const getLanguageFromUrl = (): string => {
  const params = new URLSearchParams(window.location.search);
   return activeLanguage.includes(params.get(LANGUAGE_PARAM) || "") ? params.get(LANGUAGE_PARAM) || DEFAULT_LANGUAGE : DEFAULT_LANGUAGE;
};